import { useState, useEffect, useCallback } from 'react';
import '../styles/AdminPromociones.css';

const FORM_VACIO = { texto: '', activa: true };

export default function AdminPromociones({ isOpen, onClose }) {
  const [items, setItems] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [form, setForm] = useState({ ...FORM_VACIO });
  const [editandoId, setEditandoId] = useState(null);
  const [error, setError] = useState('');
  const [exito, setExito] = useState('');
  const [mostrando, setMostrando] = useState('lista'); // 'lista' | 'form'
  const [confirmando, setConfirmando] = useState(null);

  const cargar = useCallback(() => {
    setCargando(true);
    fetch('/api/promociones')
      .then(r => r.json())
      .then(data => { setItems(Array.isArray(data) ? data : []); setCargando(false); })
      .catch(() => setCargando(false));
  }, []);

  useEffect(() => {
    if (isOpen) cargar();
  }, [isOpen, cargar]);

  if (!isOpen) return null;

  const mostrarExito = (msg) => {
    setExito(msg);
    setTimeout(() => setExito(''), 3000);
  };

  const abrirNuevo = () => {
    setForm({ ...FORM_VACIO });
    setEditandoId(null);
    setError('');
    setMostrando('form');
  };

  const abrirEditar = (item) => {
    setForm({ texto: item.texto, activa: item.activa });
    setEditandoId(item._id);
    setError('');
    setMostrando('form');
  };

  const guardar = async () => {
    setError('');
    if (!form.texto.trim()) { setError('El texto no puede estar vacío'); return; }
    try {
      const url = editandoId ? `/api/promociones/${editandoId}` : '/api/promociones';
      const method = editandoId ? 'PATCH' : 'POST';
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Error al guardar'); return; }
      cargar();
      mostrarExito(editandoId ? 'Promoción actualizada' : 'Promoción creada');
      setMostrando('lista');
    } catch {
      setError('Error de conexión');
    }
  };

  const toggleActiva = async (item) => {
    await fetch(`/api/promociones/${item._id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ activa: !item.activa }),
    });
    cargar();
  };

  const eliminar = async (id) => {
    await fetch(`/api/promociones/${id}`, { method: 'DELETE' });
    setConfirmando(null);
    cargar();
  };

  return (
    <div className="ap-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="ap-panel">

        {/* Header */}
        <div className="ap-header">
          <div className="ap-header-left">
            {mostrando !== 'lista' && (
              <button className="ap-btn-back" onClick={() => setMostrando('lista')}>← Volver</button>
            )}
            <h2 className="ap-titulo">
              {mostrando === 'lista' ? '📣 Promociones y avisos' : (editandoId ? '✎ Editar' : '+ Nueva promoción')}
            </h2>
          </div>
          <div className="ap-header-right">
            {mostrando === 'lista' && (
              <button className="ap-btn-nuevo" onClick={abrirNuevo}>+ Nueva</button>
            )}
            <button className="ap-btn-cerrar" onClick={onClose}>✕</button>
          </div>
        </div>

        {exito && <div className="ap-exito">{exito}</div>}

        {/* Lista */}
        {mostrando === 'lista' && (
          <div className="ap-body">
            {cargando && <p className="ap-vacio">Cargando...</p>}
            {!cargando && items.length === 0 && (
              <p className="ap-vacio">No hay promociones. Creá la primera con el botón "+ Nueva".</p>
            )}
            <div className="ap-lista">
              {items.map(item => (
                <div key={item._id} className={`ap-item${item.activa ? '' : ' inactiva'}`}>
                  <div className="ap-item-texto">{item.texto}</div>
                  <div className="ap-item-acciones">
                    <button
                      className={`ap-toggle${item.activa ? ' on' : ' off'}`}
                      onClick={() => toggleActiva(item)}
                      title={item.activa ? 'Desactivar' : 'Activar'}
                    >
                      {item.activa ? '● Activa' : '○ Inactiva'}
                    </button>
                    <button className="ap-btn-editar" onClick={() => abrirEditar(item)}>✎</button>
                    {confirmando === item._id ? (
                      <span className="ap-confirmar">
                        <button className="ap-si" onClick={() => eliminar(item._id)}>Sí</button>
                        <button className="ap-no" onClick={() => setConfirmando(null)}>No</button>
                      </span>
                    ) : (
                      <button className="ap-btn-eliminar" onClick={() => setConfirmando(item._id)}>🗑</button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <p className="ap-ayuda">
              Las promociones activas se muestran en rotación automática en la tienda, debajo del nombre.
            </p>
          </div>
        )}

        {/* Form */}
        {mostrando === 'form' && (
          <div className="ap-body">
            {error && <p className="ap-error">{error}</p>}

            <div className="ap-campo">
              <label>Texto de la promoción *</label>
              <textarea
                rows={3}
                placeholder='Ej: Pagá en 3 cuotas sin interés · Envío gratis en compras +$50.000'
                value={form.texto}
                onChange={e => setForm(f => ({ ...f, texto: e.target.value }))}
                autoFocus
              />
            </div>

            <label className="ap-check-label">
              <input
                type="checkbox"
                checked={form.activa}
                onChange={e => setForm(f => ({ ...f, activa: e.target.checked }))}
              />
              Mostrar en la tienda (activa)
            </label>

            <div className="ap-form-footer">
              <button className="ap-btn-cancelar" onClick={() => setMostrando('lista')}>Cancelar</button>
              <button className="ap-btn-guardar" onClick={guardar}>
                {editandoId ? 'Guardar cambios' : 'Crear promoción'}
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
